export default __webpack_public_path__ + "static/cafe_36000-2e4c87e17aea33f643a92966e61bc2a6.png";